var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('vs-tabs',{attrs:{"vs-alignment":"fixed","alignment":"fixed"}},[_c('vs-tab',{staticClass:"mt-2",attrs:{"label":_vm.$t('ActiveDiscounts')}},[_c('active-discounts')],1),_c('vs-tab',{staticClass:"mt-2",attrs:{"label":_vm.$t('ArchiveDiscounts')}},[_c('archive-discounts')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }